module.exports = __webpack_public_path__ + "img/dtk@2x.1adc948b.png";